import FollowUpCareSurface from '@/components/FollowUp/FollowUpCareSurface';

/**
 * FollowUpTab — the People profile Follow Up tab (spec §6.2). Renders the
 * care surface (the legacy /follow-up/people/[personID] route redirects here);
 * the tab itself is only
 * offered when the viewer has 'View Follow Up' (gated in
 * people/[personID].jsx activityRoutes).
 */
const FollowUpTab = ({ personID }) => {
    return <FollowUpCareSurface personID={personID} />;
};

export default FollowUpTab;
